document.addEventListener('DOMContentLoaded', function () {
  const siteHeader = document.querySelector('.site-header');
  const navToggle = document.querySelector('.toggle-header-nav');
  const headerOverlay = document.querySelector('.header-overlay');

  function openMenu() {
    siteHeader.classList.add('active');
    headerOverlay.classList.add('active');
    navToggle.classList.add('active');
    navToggle.querySelector('.toggle-text').textContent = 'Close';
  }

  function closeMenu() {
    siteHeader.classList.remove('active');
    headerOverlay.classList.remove('active');
    navToggle.classList.remove('active');
    navToggle.querySelector('.toggle-text').textContent = 'Menu';
  }

  if(navToggle) {
    navToggle.addEventListener('click', function () {
      if(navToggle.classList.contains('active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if(headerOverlay) {
    headerOverlay.addEventListener('click', function () {
      closeMenu();
    });
  }
});